import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

const LandingBlogSection = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const WP_API_URL = process.env.REACT_APP_WP_API_URL || 'https://mycashcanvas.com/wp/wp-json/wp/v2/posts';

  useEffect(() => {
    setLoading(true);
    fetch(`${WP_API_URL}?per_page=3&_embed`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch posts');
        return res.json();
      })
      .then((data) => {
        setPosts(data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching posts:', err);
        setPosts([]);
        setLoading(false);
      });
  }, []);

  return (
    <section className="py-16 bg-background-main">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold mb-4 text-btn-primary text-center">Our Latest Articles</h2>
        <p className="text-md text-gray-700 mb-8">
          Expert tips, product updates, and inspiring stories to help you master your money journey.
        </p>

        {loading && <p className="text-center py-6">Loading articles…</p>}

        {!loading && posts.length === 0 && (
          <p className="text-center text-gray-500 py-6">No articles available</p>
        )}

        <div className="grid md:grid-cols-3 gap-8">
          {posts.map((post) => {
            const featured = post._embedded?.['wp:featuredmedia']?.[0];
            const image = featured?.source_url || '';
            const excerpt = post.excerpt?.rendered || '';
            const slug = post.slug || '';

            return (
              <article
                key={post.id}
                className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow overflow-hidden flex flex-col border border-gray-100 cursor-pointer"
                onClick={() => navigate(`/${slug}`)}
              >
                {image && <img src={image} alt={post.title?.rendered} className="h-40 w-full object-cover" />}
                <div className="p-4 flex flex-col flex-1">
                  <h3 className="text-lg font-semibold mb-1 text-btn-primary" dangerouslySetInnerHTML={{ __html: post.title?.rendered }} />
                  <div className="text-gray-700 mb-4 flex-1" dangerouslySetInnerHTML={{ __html: excerpt }} />
                  <div className="flex gap-2 mt-auto">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/${slug}`);
                      }}
                      className="flex-1 px-4 py-2 rounded bg-btn-secondary text-white hover:bg-opacity-90 transition-colors font-semibold"
                    >
                      Read More
                    </button>
                    <a
                      href={post.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      className="px-4 py-2 rounded bg-btn-primary text-white hover:bg-opacity-90 transition-colors font-semibold"
                    >
                      ↗
                    </a>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LandingBlogSection;